var render = function render(){var _vm=this,_c=_vm._self._c;return _c('APCDelconCreateAdmin',{attrs:{"APCD":_vm.APCD,"shippingCompanies":_vm.shippingCompanies,"ordersFBM":_vm.ordersFBM},on:{"saveAPCDelcon":_vm.saveAPCDelcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }